import React, { FC } from 'react'
import { DatasetRule } from 'tabs/data/api/generated'

import { DatasetRuleItem } from './DatasetRuleItem'
import { CButton } from 'tabs/data/components/CButton'

type DatasetRulesProps = {
  disabled?: boolean
  rules: DatasetRule[]
  onChange: (rules: DatasetRule[]) => void
}

export const DatasetRules: FC<DatasetRulesProps> = ({ rules, disabled = false, onChange }) => {
  const hasRules = rules?.length > 0

  const handleAddRule = () => {
    onChange([...rules, {}])
  }

  const handleDeleteRule = (index: number) => {
    const next = rules.filter((i, idx) => idx !== index)
    onChange(JSON.parse(JSON.stringify(next || [])))
  }

  return (
    <div
      style={
        hasRules
          ? {
              width: '100%',
              padding: '1rem 0 1rem 1rem',
              borderLeft: '1px solid #ddd',
            }
          : { width: '100%', padding: '1rem 0' }
      }>
      {rules?.map((item: DatasetRule, index) => (
        <DatasetRuleItem
          key={item?.id + index + item.type}
          index={index}
          data={item}
          disabled={disabled}
          onChange={(rule, type) => {
            const nextRules = rules
            const ruleId = nextRules[index].id
            nextRules[index] = { rule, type, id: ruleId }

            if (ruleId) {
              nextRules[index].id = ruleId
            }

            onChange([...nextRules])
          }}
          onDelete={handleDeleteRule}
        />
      ))}

      <CButton
        disabled={disabled}
        label={hasRules ? '+ Add rule' : 'Create rule'}
        variant="outlined"
        style={hasRules ? { height: '32px' } : { margin: '-0.5rem 0' }}
        onClick={handleAddRule}
      />
    </div>
  )
}
